import { useState } from "react";
import BoxControls from "../../Common/Box/BoxControls";
import IncomeGroupChooser from "../../Common/Box/Choosers/IncomeGroupChooser";
import Figure from "../../Common/Box/Figure";
import initialData from "../../../data/initialData.json";
import useAreaQuery from "../../../hooks/useAreaQuery";
import { getIncomeGroup, getTooltip } from "../../../utilities";

const number = 8;

const getSeriesColor = (name) => {
  switch (name) {
    case "2019":
      return "#c193ac";

    case "2025":
      return "#ac6f90";

    case "2030":
      return "#7d4765";

    default:
      return "black";
  }
};

const options = (data, props) => (theme) => {
  const series = data.map((series) => ({
    ...series,
    color: getSeriesColor(series.name),
  }));

  return {
    chart: {
      type: "column",
      width: 470,
      height: 300,
      backgroundColor: null,
    },
    xAxis: {
      categories: [
        "1: Maintain safety profile & method mix",
        "2: Shift safety profile",
        "3: Shift safety profile & method mix",
      ],
    },
    yAxis: {
      title: undefined,
      labels: {
        formatter: function () {
          return "$" + this.axis.defaultLabelFormatter.call(this);
        },
      },
    },
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: function () {
        return getTooltip("Cost", this.y, this.percentage, {
          prefix: "$",
        });
      },
      style: {
        fontSize: "0.875rem",
        color: theme.palette.tooltip.primary,
      },
    },
    exporting: {
      chartOptions: {
        title: undefined,
        subtitle: undefined,
      },
      enabled: false,
    },
    series,
  };
};

const Component = (props) => {
  const [selectedIncomeGroupId, setSelectedIncomeGroupId] = useState(0);

  const { areaData: data } = useAreaQuery(
    `/apac/figures/8/${selectedIncomeGroupId}`,
    initialData["apac_f8"]
  );

  const handleIncomeGroupChange = (incomeGroupId) => {
    setSelectedIncomeGroupId(incomeGroupId);
  };

  return (
    <Figure
      id="APAC_f8"
      number={number.toString()}
      fileStem={`apac_f${number}`}
      title="Change in Cost of Abortion and PAC Supplies"
      subtitle="By Future Scenario, 2019-2030"
      chartOptions={options(data)}
      selection={getIncomeGroup(selectedIncomeGroupId)}
      controls={
        <BoxControls>
          <IncomeGroupChooser
            value={selectedIncomeGroupId}
            onChange={handleIncomeGroupChange}
          />
        </BoxControls>
      }
    />
  );
};

export default Component;
